export default __webpack_public_path__ + "static/media/guide-3.fe55b700.png";